export const MAP_UTILITIES_SEND_MESSAGE = "MAP_UTILITIES_SEND_MESSAGE";
export const MAP_UTILITIES_SEND_MESSAGE_RESPONSE = "MAP_UTILITIES_SEND_MESSAGE_RESPONSE";